import "../index.css";
import Nav from "./navbar";
import Footer from "./footer";
import "../styles.css";
import { Link } from 'react-router-dom';
import { Component } from "react";

class NotFound extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <>
                <Nav />
                <div className="container-404">
                    <div className="heading-404">
                        <span className="hover-404">4</span><span className="hover-404">0</span><span className="hover-404">4</span>

                    </div><div className="sub-heading-404 hover-404">
                        Lost Your Way?

                    </div>
                    <div ><br /><br /><Link className="btn-grad-404" to="/" >Back To Home</Link></div>
                </div>
                <div style={{ position: "fixed", bottom: "0", left: "0", right: "0" }}>
                    <Footer /></div>
            </>
        );
    }
}

export default NotFound;
